<template>
  <div>
    <ModalRangoFechas
      :showModalVisibilidad="showModalRangoFechas"
      @close="closeModalRangoFechas"
      @handleRangoFechas="handleRangoFechas"
    ></ModalRangoFechas>

    <div v-if="!noShowSetpoint">
      <div
        class="text-xs col-span-2 border-solid border-0 border-indigo-300 pl-2 pr-2 pt-4 text-left"
      >
        <span v-if="result_mediciones_haydatos"
          ><span class="green custom-shadow"></span
        ></span>

        <span v-if="this.idEstado === 9"
          ><span class="red custom-shadow"></span
        ></span>
        <span v-if="this.idEstado === 1"
          ><span class="green custom-shadow"></span
        ></span>
        <span v-if="this.idEstado === 2"
          ><span class="blue custom-shadow"></span
        ></span>
        <span v-if="this.idEstado === 3"
          ><span class="yellow custom-shadow"></span
        ></span>
        <span v-if="this.idEstado === 4"
          ><span class="orange custom-shadow"></span
        ></span>
        <span v-if="result_mediciones_haydatos == false">
          <!-- <span class="inline-block h-5 w-5 bg-gray-400 rounded-full"></span>  -->
          <span class="red custom-shadow"></span>
        </span>
        <span class="text-lg font-bold ml-2"> {{ objJaula.descripcion }} </span>
        <br />
        <span class="text-xs font-bold ml-2 text-blue-800">
          {{ $t("historial") }}: {{ startDate }} / {{ endDate }}
          <a href="#" class="" @click.prevent="openModalGrafico(objJaula)"
            ><u> {{ $t("ampliar_grafico") }}</u></a
          >
        </span>
      </div>
      <div
        class="grid grid-cols-4 md:grid-cols-4 lg:grid-cols-4 gap-2 pl-1 pr-1"
      >
        <div
          v-if="Object.keys(reqO2).length > 0"
          class="text-xs text-blue-600 border-solid border-0 border-indigo-300 pl-2 pr-2 pt-4 text-center"
        ></div>
        <div
          v-if="Object.keys(maxMgl).length > 0"
          class="text-xs text-blue-600 border-solid border-0 border-indigo-300 pl-2 pr-2 pt-4 text-center"
        ></div>
        <div
          v-if="Object.keys(maxORP).length > 0"
          class="text-xs text-purple-800 border-solid border-0 border-indigo-300 pl-2 pr-2 pt-4 text-center"
        ></div>
      </div>
      <div
        class="grid grid-cols-4 md:grid-cols-4 lg:grid-cols-4 ml-1 mr-1 pb-0"
      >
        <div
          class="text-xs border-solid border-0 border-indigo-300 p-2 text-center pt-7"
        >
          Temp &deg;C
        </div>
        <div
          v-if="Object.keys(reqO2).length > 0"
          class="text-xs text-blue-600 border-solid border-0 border-indigo-300 pl-2 pr-2 pt-4 text-center"
        >
          {{ this.reqO2.descripcion }} {{ reqO2_ume }}
        </div>
        <div
          v-if="Object.keys(maxMgl).length > 0"
          class="text-xs text-blue-600 border-solid border-0 border-indigo-300 pl-2 pr-2 pt-4 text-center"
        >
          {{ this.maxMgl.descripcion }} {{ maxMgl_ume }}
        </div>
        <div
          v-if="Object.keys(maxORP).length > 0"
          class="text-xs text-purple-800 border-solid border-0 border-indigo-300 pl-2 pr-2 pt-4 text-center"
        >
          {{ this.maxORP.descripcion }} {{ maxORP_ume }}
        </div>
      </div>

      <div
        class="grid grid-cols-4 md:grid-cols-4 lg:grid-cols-4 ml-1 mr-1 pb-0"
      >
        <div
          class="text-xs border-l-2 border-t-2 border-b-2 border-r-0 border-solid border-indigo-300 p-2 text-center"
        >
          {{ this.ulttemp }}
        </div>

        <div
          v-if="Object.keys(reqO2).length > 0"
          class="text-xs border-l-2 border-t-2 border-b-2 border-r-2 border-indigo-300 p-2 text-center"
        >
          {{ this.ultmaxmgl }}
        </div>
        <div
          v-if="Object.keys(maxMgl).length > 0"
          class="text-xs border-l-2 border-t-2 border-b-2 border-r-2 border-indigo-300 p-2 text-center"
        >
          {{ this.ultmgl }}
        </div>
        <div
          v-if="Object.keys(maxORP).length > 0"
          class="text-xs border-l-2 border-t-2 border-b-2 border-r-2 border-indigo-300 p-2 text-center bg-gray-200"
        >
          {{ this.ultorp }}
        </div>
      </div>
      <div
        class="grid grid-cols-4 md:grid-cols-4 lg:grid-cols-4 ml-1 mr-1 mb-4"
      >
        <div
          class="text-xs border-solid border-0 border-indigo-300 p-2 text-center pt-7"
        >
          Set Points
        </div>
        <div
          v-if="Object.keys(reqO2).length > 0"
          class="text-xs border-l-2 border-t-2 border-b-2 border-r-0 bg-blue-600 border-indigo-300 p-2 text-center"
        >
          <!-- SETPOINT SATURADO // requerido -->

          <input
            @click_desabilitado="openmodal('reqO2', reqO2_esDefault)"
            type="text"
            v-model="reqO2.value"
            :class="[
              'text-center w-full text-xs p-2 h-8 shadow-sm border-solid border-2 border-blue-600',
              reqO2_esDefault ? 'bg-orange-100' : 'bg-white',
            ]"
          />
        </div>
        <div
          v-if="Object.keys(maxMgl).length > 0"
          class="text-xs border-l-2 border-t-2 border-b-2 border-r-0 bg-blue-600 border-indigo-300 p-2 text-center"
        >
          <!-- SETPOINT OXIGENO DISUELTO // requerido -->

          <input
            @click_desabilitado="openmodal('maxMgl', maxMgl_esDefault)"
            type="text"
            v-model="maxMgl.value"
            :class="[
              'text-center w-full text-xs p-2 h-8 shadow-sm border-solid border-2 border-blue-600 ',
              maxMgl_esDefault ? 'bg-orange-100' : 'bg-white',
            ]"
          />
        </div>
        <div
          v-if="Object.keys(maxORP).length > 0"
          class="text-xs border-solid border-2 border-indigo-300 p-2 text-center bg-purple-800"
        >
          <!-- SET POINT ORP-->
          <!--  @click="openmodal('maxORP',maxORP_esDefault)"  -->
          <input
            type="text"
            v-model="maxORP.value"
            :class="[
              'text-center text-xs w-full p-2 h-8 shadow-sm border-solid border-purple-800 border-2 ',
              maxORP_esDefault ? ' bg-gray-200' : 'bg-white',
            ]"
          />
        </div>
      </div>
    </div>
    <div class="chart-container">
      <SpinnerLoading v-show="result_mediciones == false"></SpinnerLoading>

      <!-- graficochart historico-->

       <div v-if=" noShowSetpoint">     

    <div v-if="!esModal || esModal" :class="[
        'grid gap-0 mx-auto bg-gray-100 rounded-lg shadow-lg mb-1  pt-0',
        esModal === true ? 'grid-cols-8 md:grid-cols-8 lg:grid-cols-8 pl-0 pr-0' : ' pl-1 pr-1 grid-cols-4 md:grid-cols-4 lg:grid-cols-4',
        noShowSetpoint ? 'w-[1200px]' : 'w-full']">
  <!-- Primera columna -->
  <div class="text-center   pl-0 h-full   ">
   <span class="text-xs font-bold">{{ $t('o2_disuelto') }} mg/l</span>
  </div>

  <!-- Segunda columna -->
  <div class="text-center ml-1   mb-1 h-full flex flex-col justify-center">
    <div class="flex justify-between">
      <div class="w-1/2 text-left">
        <div class="mt-1 h-1 bg-[#01FFFF] shadow-lg ml-auto"></div>
      </div>
      <div class="w-1/2 text-right">
        <div class="mt-1 h-1 bg-[#0099FF] shadow-lg ml-auto"></div>
      </div>
    </div>
    <div class="flex justify-between mt-1">
      <div class="w-1/2 text-left pr-3">
        <span class="text-[#00e0e0] text-xs">{{ $t('con_inyeccion') }}</span>
      </div>
      <div class="w-1/2 text-left ml-2">
        <span class="text-[#0099FF] text-xs">{{ $t('sin_inyeccion') }}</span>
      </div>
    </div>
  </div>

  <!-- Tercera columna -->
  <div class="text-center w-full h-full  ">
    <span class="text-xs font-bold">{{ $t('temperatura_celsius') }}</span>
  </div>

  <!-- Cuarta columna -->
  <div class="text-center mt-1   mb-2 h-full   ">
    <div class="mt-1 h-1 bg-[#FF6E00] rounded-lg shadow-lg w-full"></div>
  </div>

  <!-- Quinta columna -->
  <div class="text-center mt-0  pl-1   h-full ">
    <span class="text-xs font-bold">{{ $t('oxigeno_saturado') }} %</span>
  </div>

  <!-- Sexta columna -->
  <div class="text-center  h-full flex flex-col justify-center">
    <div class="flex justify-between">
      <div class="w-1/2 text-left">
        <div class="mt-1 h-1 bg-[#7fff00] shadow-lg ml-auto"></div>
      </div>
      <div class="w-1/2 text-right">
        <div class="mt-1 h-1 bg-[#395172] shadow-lg ml-auto"></div>
      </div>
    </div>
    <div class="flex justify-between mt-1">
      <div class="w-1/2 text-left pr-1">
        <span class="text-[#69ce04] text-xs">{{ $t('con_inyeccion') }}</span>
      </div>
      <div class="w-1/2 text-left ml-2">
        <span class="text-[#395172] text-xs">{{ $t('sin_inyeccion') }}</span>
      </div>
    </div>
  </div>


   <!-- sept columna -->
        <div v-if="esModal" class="text-center mt-0">
          <a   @click="loadModalRangoFechas(true)" href="#"
            class=" m-2 group flex flex-col items-center justify-between p-3   rounded-lg transition duration-150 ease-in-out hover:bg-green-50 bg-gray-200">
            <p class="text-xs text-gray-900">{{ $t('calendario') }}</p>
          </a>

        </div>
        <!-- oct columna -->
        <div v-if="esModal" class="text-center mt-0">
          <a @click="loadGraficoLive()" href="#"
            class=" m-2 group flex flex-col items-center justify-between p-3   rounded-lg transition duration-150 ease-in-out hover:bg-green-50 bg-gray-200">
            <p class="text-xs text-gray-900">
              {{ $t('horas') }}
            </p>
          </a>

        </div>
</div>
</div>


      <div class="w-full flex justify-center">
        <AlertDummy
          v-show="glosaDummyO2Disuelto != ''"
          :glosa="glosaDummyO2Disuelto"
        ></AlertDummy>
        <AlertDummy
          v-show="glosaDummyO2Saturado != ''"
          :glosa="glosaDummyO2Saturado"
        ></AlertDummy>
        <AlertDummy
          v-show="glosaDummyTemperatura != ''"
          :glosa="glosaDummyTemperatura"
        ></AlertDummy>
        <AlertDummy
          v-show="glosaDummyOzono != ''"
          :glosa="glosaDummyOzono"
        ></AlertDummy>
      </div>

      <div class="w-full" @click.prevent="openModalGrafico(objJaula)">
     <highcharts :options="chartOptions"></highcharts>
      </div>
    </div>
    <div class="chart-container">
      <div id="divfec" class="w-full flex justify-between">
        <div class="f1 pl-11 text-xs text-center">
          <!--    {{ firstdate }}<br>{{ firsthour }}-->
          {{ fechaInicialParche }}
          <br />
          {{ horaInicialParche }}
        </div>
        <div class="flex-grow text-xs text-center">
          {{ fechaMitadParche }}
          <br />
          {{ horaMitadParche }}
        </div>
        <div class="f2 text-xs text-center ml-1 pr-12">
          <!--     {{ lastdate }}<br>{{ lasthour }}-->

          {{ fechaFinalParche }}
          <br />
          {{ horaFinalParche }}
        </div>
      </div>
    </div>

    <textarea
      id="adjustable-textarea"
      class="w-full p-2 border border-gray-300 rounded text-xs focus:outline-none focus:ring-2 focus:ring-blue-500 text hidden "
      v-model="this.fs3"
    ></textarea>

    <textarea
      id="adjustable-textarea"
      class="w-full p-2 border border-gray-300 rounded text-xs focus:outline-none focus:ring-2 focus:ring-blue-500 text  hidden"
      v-model="this.fs2"
    ></textarea>
    <!-- {{ this.chartOptions.series[0].zones  }} -->
  </div>
</template>
<script>
import { Chart } from "highcharts-vue";
import Highcharts from "highcharts";
import stockInit from "highcharts/modules/stock";
import SpinnerLoading from "../SpinnerLoading";
import AlertDummy from "../AlertDummy.vue";
import ModalRangoFechas from "./modal/ModalRangoFechas";
import axios from "axios";
import { DateTime } from "luxon";
import i18n from "@/i18n";
stockInit(Highcharts);
const offset = -DateTime.now().setZone("America/Santiago").offset;
//const colors = Highcharts.getOptions().colors;
Highcharts.setOptions({
  chart: {},
  time: {
    timezoneOffset: offset, // Chile horario de invierno (manual)
  },
});

export default {
  props: [
    "propIdFaena",
    "objJaula",
    "startDate",
    "endDate",
    "noShowSetpoint",
    "esModal",
    "abreCalendario",
  ],
  emits: ["ampliaGrafico", "muestraFoto", "fecha_hasta"],

  components: {
    highcharts: Chart,
    SpinnerLoading,

    AlertDummy,
    ModalRangoFechas,
  },
  data: function () {
    return {
      oxigenoValuesGlobal: [],
      showModalRangoFechas: false,
      objRangoFechas: {},
      objJaulaSeleccionada: {},
      glosaDummyO2Saturado: "",
      glosaDummyO2Disuelto: "",
      glosaDummyTemperatura: "",
      glosaDummyOzono: "",
      fs: "",
      fs2: "",
      fs3: "",
      modalstate: false,
      modalgraficostate: false,
      idEstado: 5,
      setpoint1: 6.2,
      setpoint2: 300,
      idJaula: 0,
      ultfecha: "",
      ultmgl: "--",
      ultmaxmgl: "--",
      ultorp: "--",
      ulttemp: "--",
      temperatura: "--",
      saturacion: 0,
      idSensorAFiltrar0: 0,
      idSensorAFiltrar1: 0,
      granularity: "HOUR", // DAY, HOUR

      id1: 0,
      id2: 0,
      sensores: [],
      sensor: [
        { id: "", nombre: "" },
        { id: "", nombre: "" },
      ],

      fInicial: "",
      fFinal: "",

      reqO2: {},
      maxORP: {},
      maxMgl: {},
      reqO2_tipo: "",
      maxORP_tipo: "",
      maxMgl_tipo: "",
      reqO2_ume: "",
      maxORP_ume: "",
      maxMgl_ume: "",
      reqO2_esDefault: "",
      maxORP_esDefault: "",
      maxMgl_esDefault: "",
      datosSetPoint: {},
      descripcionSetPoint: "",
      ume1: "",
      ume2: "",
      tipo1: "",
      tipo2: "",
      result_mediciones: true,
      result_mediciones_haydatos: false,
      firstdate: "",
      firsthour: "",
      lastdate: "",
      lasthour: "",
      middledate: "",
      middlehour: "",
      fechaInicialParche: "",
      horaInicialParche: "",
      fechaFinalParche: "",
      horaFinalParche: "",
      fechaMitadParche: "",
      horaMitadParche: "",

      valorMaxY_O2: 0,
      valorMinY_O2: 0,
      valorMaxY_temp: 0,
      valorMinY_temp: 0,
      valorMaxY_o2saturado: 0,
      valorMinY_o2saturado: 0,
      minY: 0,
      maxY: 5,
      minY_temp: 0,
      maxY_temp: 15,
      chartOptions: {
        chart: {
          type: "line",
        },
        title: {
          text: "",
        },
    colors: ['#0099ff', '#ff6e00', '#395172'], // Colores de las series
        xAxis: {
          categories: [],
          labels: {
            enabled: true, // Deshabilitar etiquetas del eje X
            lineColor: "gray",
          },
        },
        yAxis: [
          {
            title: {
              text: "",
              style: {
                color: "#0037ff",
              },
            },
            min: 0,
            max: 0,
            labels: {
              style: {
                color: "#0037ff",
              },
            },
          },
          {
            opposite: true,
            title: {
              text: "°C",
              style: {
                color: "#ff6e00",
              },
            },
            min: 0,
            max: 0,
            labels: {
              style: {
                color: "#ff6e00",
              },
            },
            formatter: function (val) {
              return val.toFixed(2);
            },
          },
          {
            opposite: true,
            title: {
              text: "mg/l",
              style: { color: "#395172" },
            },
            min: 0,
            max: 0,
            labels: {
              style: { color: "#395172" },
            },
          },
        ],
        plotOptions: {
          line: {
            dataLabels: {
              enabled: false,
            },
            enableMouseTracking: true,
          },
        },
        legend: {
          enabled: false, // Ocultar la leyenda
        },
        series: [
          {
            name: "", // Nombre de la primera serie
            data: [0, 0, 0, 0], // Datos para la primera serie
            yAxis: 0, // Indica que esta serie usa el primer eje Y (el izquierdo),
            zones: [],
            zoneAxis: "x",
            marker: {
              enabled: false,
            },
          },
          {
            name: "", // Nombre de la segunda serie
            data: [], // Datos para la segunda serie
            yAxis: 1, // Indica que esta serie usa el primer eje Y (el izquierdo)
            marker: {
              enabled: false,
            },
          },
          {
           name: '',
            data: [],
            yAxis: 2,
            zones: [],
               zoneAxis: 'x',
            marker: { enabled: false },
          },
        ],
        tooltip: {},
      },
    };
  },
  methods: {
    loadGraficoLive() {
      this.$emit("loadGraficoLive", this.objJaula);
    },
    loadOpcionesHoras() {
      this.modalstate = true;
    },
    loadModalRangoFechas(valor) {
      console.log("modifica estado modal");
      this.showModalRangoFechas = valor;
    },
    closeModalRangoFechas() {
      this.showModalRangoFechas = false;
    },
    handleRangoFechas(valor) {
      console.log("handleRangoFecs", valor);

      this.objRangoFechas = valor;
      this.showModalRangoFechas = false;
    },
    getRnd(min, max) {
      let flot = Math.random() * (max - min + 1) + min;

      return flot.toFixed(2);
    },
    getRndUno(min, max) {
      let flot = Math.random() * (max - min + 1) + min;

      return flot.toFixed(1);
    },
    propagajaula() {
      this.$emit("muestraFoto", this.idJaula, this.label);
    },
    polldata() {},

    closeModal() {
      this.modalstate = false;
    },
    closeModalGrafico() {
      this.modalgraficostate = false;
    },
    updateNuevoDato(datos) {
      console.log("updateNuevoDato", datos);
      if (datos.parametro == "reqO2") {
        this.reqO2.value = datos.value;
      }
      if (datos.parametro == "maxMgl") {
        this.maxMgl.value = datos.value;
      }
      this.modalstate = false;
    },

    getdataendpoint(startDate, endDate) {
      this.result_mediciones = false;
      if (!startDate) {
        let objFecha = this.$store.getters.fechaHoraActual(this.propIdFaena);
        const y = objFecha.getFullYear;
        const m = String(objFecha.getMonth + 1).padStart(2, "0"); // Los meses   son 0-11
        const d = String(objFecha.getDate).padStart(2, "0");
        startDate = `${y}-${m}-${d}`;
        endDate = `${y}-${m}-${d}`;
      }

      //------------------------------- borrar

      this.chartOptions.xAxis.categories = [];
      this.chartOptions.series[1].data = [0];
      this.chartOptions.series[0].data = [];
      this.chartOptions.series[0].zones = [];

      let objFecha = this.$store.getters.fechaHoraActual(this.propIdFaena);
      const y = objFecha.getFullYear;
      const m = String(objFecha.getMonth + 1).padStart(2, "0"); // Los meses   son 0-11
      const d = String(objFecha.getdataendpoint).padStart(2, "0");

      const h = String(objFecha.getHours).padStart(2, "0");
      const min = String(objFecha.getMinutes).padStart(2, "0");
      const s = String(objFecha.getSeconds).padStart(2, "0");
      let fechaHoraStr = `${y}-${m}-${d} ${h}:${min}:${s}`;

      if (startDate) {
        fechaHoraStr = `${startDate}T${h}:${min}:${s}`;
      }

      let objFechaHora = this.$store.getters.objDate(
        fechaHoraStr,
        `${h}:${min}:${s}`,
        this.propIdFaena
      );
      var nuevoFormato = {
        year: objFechaHora.getFullYear,
        month: String(objFechaHora.getMonth).padStart(2, "0"),
        day: String(objFechaHora.getDate).padStart(2, "0"),
        hours: String(objFechaHora.getHours).padStart(2, "0"),
        minutes: String(objFechaHora.getMinutes).padStart(2, "0"),
        seconds: String(objFechaHora.getSeconds).padStart(2, "0"),
      };

      this.fInicial = `${nuevoFormato.year}-${nuevoFormato.month}-${nuevoFormato.day}T${nuevoFormato.hours}:${nuevoFormato.minutes}:${nuevoFormato.seconds}`;

      let fechaHoraStr2 = "";
      if (endDate) {
        fechaHoraStr2 = `${endDate}T${h}:${min}:${s}`;
      }

      let objFechaHora2 = this.$store.getters.objDate(
        fechaHoraStr2,
        "00:00:00",
        this.propIdFaena
      );

      var nuevoFormato2 = {
        year: objFechaHora2.getFullYear,
        month: ("0" + objFechaHora2.getMonth).slice(-2),
        day: ("0" + objFechaHora2.getDate).slice(-2),
        hours: ("0" + objFechaHora2.getHours).slice(-2),
        minutes: ("0" + objFechaHora2.getMinutes).slice(-2),
        seconds: ("0" + objFechaHora2.getSeconds).slice(-2),
      };

      this.fFinal = `${nuevoFormato2.year}-${nuevoFormato2.month}-${nuevoFormato2.day}T${nuevoFormato2.hours}:${nuevoFormato2.minutes}:${nuevoFormato2.seconds}`;
      const dias = this.$store.getters.calcularDiferencia(
        this.fInicial,
        this.fFinal,
        this.propIdFaena
      ).dias;

      console.log("dias", dias);

      /*  if (dias >= 60) {
        this.granularity = "DAY";
      } else {
        this.granularity = "HOUR";
      } */

      const frecuencia_minutos = dias * 24 * 60;
      const vista = "live-ampliado";
      this.granularity = this.$store.getters.calculaPuntosGranularidad(
        frecuencia_minutos,
        vista
      );

      if (!this.idJaula) {
        return false;
      }
      if (!this.sensor) {
        return false;
      }

      const apiKey = this.$store.state.login.tokenLogin;
      const data = {
        idUnit: this.idJaula,
        tsi: `${this.fInicial}`,
        tsf: `${this.fFinal}`,
        granularity: `${this.granularity}`,
      };

      const fetchData = async () => {
        try {
          const url = "/api/mon/getUnitData";
          const response = await axios.post(url, data, {
            headers: {
              "Content-Type": "application/json",
              Authorization: `${apiKey}`,
            },
          });

          this.glosaDummyO2Saturado = "";
          this.glosaDummyO2Disuelto = "";
          const datos = response.data.payload.sensors;
          if (Array.isArray(datos) && datos.length == 0) {
            this.fechaInicialParche = this.fInicial
              .split(" ")[0]
              .split("-")
              .reverse()
              .join("-");
            this.fechaFinalParche = this.fFinal
              .split(" ")[0]
              .split("-")
              .reverse()
              .join("-");
            return false;
          }

          this.valorMaxY_O2 = 0;
          this.valorMinY_O2 = 0;
          this.valorMaxY_temp = 0;
          this.valorMinY_temp = 0;
          this.valorMaxY_o2saturado = 0;
          this.valorMinY_o2saturado = 0;

          let temperaturaValues = [];
          let oxigenoValues = [];
          let oxigenoSaturadoValues = [];
          let orpValues = [];

          this.idSensorAFiltrar1 = this.objJaula.sensores[0]; // viene de props
          this.fs3 = "datos recibidos";
          datos
            .filter((sensor) => sensor.id === this.idSensorAFiltrar1)
            .forEach((sensor) => {
              let indice = 0;

              sensor.params.forEach((param) => {
                let id = param.id;

                /*    if (id == 1 && this.idSensorAFiltrar1 == id) {
                  this.glosaDummyTemperatura = param.injectionType == 'dummy' ? `Temperatura simulada` : '';
                }
                if (id == 4 && this.idSensorAFiltrar1 == id) {
                  let gas = param.gas;
                  this.glosaDummyOzono = param.injectionType == 'dummy' ? `${gas} disuelto simulado` : '';
                }
                if (id == 5) {
                  let gas = param.gas;
                  this.glosaDummyO2Disuelto = param.injectionType == 'dummy' ? `${gas} disuelto simulado` : '';
                }
                if (id == 6 && this.idSensorAFiltrar1 == id) {
                  let gas = param.gas;
                  this.glosaDummyO2Saturado = param.injectionType == 'dummy' ? `${gas} saturado simulado` : '';
                }  */
                if (param.injectionType === "dummy") {
                  let gas = param.gas;
                  switch (id) {
                    case 1:
                      if (this.idSensorAFiltrar1 === id) {
                        this.glosaDummyTemperatura = i18n.global.t(
                          "temperatura_simulada"
                        );
                      }
                      break;
                    case 4:
                      if (this.idSensorAFiltrar1 === id) {
                        this.glosaDummyOzono = `${gas} ${i18n.global.t(
                          "disuelto_simulado"
                        )}`;
                      }
                      break;
                    case 5:
                      this.glosaDummyO2Disuelto = `${gas} ${i18n.global.t(
                        "disuelto_simulado"
                      )}`;
                      break;
                    case 6:
                      if (this.idSensorAFiltrar1 === id) {
                        this.glosaDummyO2Saturado = `${gas}  ${i18n.global.t(
                          "saturado_simulado"
                        )}`;
                      }
                      break;
                  }
                }
                let splicedData = param.values;
                splicedData.forEach((valor) => {
                  // contiene:  {'value':valor.value,'ts':valor.ts}

                  switch (id) {
                    case 1:
                      temperaturaValues.push({ ...valor });
                      this.valorMaxY_temp <= valor.value
                        ? (this.valorMaxY_temp = valor.value)
                        : (this.valorMinY_temp = valor.value);
                      this.ajusteY();
                      break;
                    case 5:
                      oxigenoValues.push({ ...valor });

                      if (indice == 0) {
                        this.valorMinY_O2 = valor.value;
                        this.valorMaxY_O2 = valor.value;
                      } else {
                        if (valor.value > this.valorMaxY_O2) {
                          this.valorMaxY_O2 = valor.value;
                        } else {
                          if (valor.value < this.valorMinY_O2) {
                            this.valorMinY_O2 = valor.value;
                          }
                        }
                      }

                      indice++;

                      this.ajusteY();
                      break;
                    case 4:
                      this.ultorp = valor.value.toFixed(2);
                      orpValues.push({ ...valor });
                      break;
                    case 6:
                      oxigenoSaturadoValues.push({ ...valor });
                      if (indice == 0) {
                        this.valorMinY_o2saturado = valor.value;
                        this.valorMaxY_o2saturado = valor.value;
                      } else {
                        if (valor.value > this.valorMaxY_o2saturado) {
                          this.valorMaxY_o2saturado = valor.value;
                        } else {
                          if (valor.value < this.valorMinY_o2saturado) {
                            this.valorMinY_o2saturado = valor.value;
                          }
                        }
                      }
                      indice++;
                      this.ajusteY();

                      this.ultmaxmgl = valor.value.toFixed(2);
                      break;
                  }

                  this.result_mediciones_haydatos = true;
                });
              });
            });

          // Procesar oxigenoValues en una promesa
          return new Promise((resolve, reject) => {
            try {
              this.chartOptions.xAxis.categories = [];
              let mediciones_oxigeno = [];
              let mediciones_o2saturado = [];
              let zones_oxigeno = [];
              let zones_o2saturado = [];
              let mediciones_temp = [];
              let ultimo_injection_tag_o2saturado;
              let categorias = [];
              this.fs2 = "";
              let ultimo_injection_tag;

              temperaturaValues.forEach((mobile) => {
                let med = mobile["value"];
                mediciones_temp.push(med);
                this.ulttemp = med.toFixed(2);
                //console.log(med)
              });

              let mitad = 0;
              mitad = Math.round(oxigenoValues.length / 2);
              this.oxigenoValuesGlobal = oxigenoValues.length + " " + mitad;

              oxigenoSaturadoValues.forEach((mobile, index) => {
                // zonas contiene  la posicion del array series

                if (index == 0) {
                  ultimo_injection_tag_o2saturado = mobile["injection"];
                } else {
                  if (mobile["injection"] !== ultimo_injection_tag_o2saturado) {
                    zones_o2saturado.push({
                      tag: mobile["injection"],
                      value: index,
                      color:
                        ultimo_injection_tag_o2saturado == false &&
                        mobile["injection"] == true
                          ? "#7fff00"
                          : "",
                    });
                  } else {
                    zones_o2saturado.push({
                      tag: mobile["injection"],
                      value: index,
                      color:
                        ultimo_injection_tag_o2saturado == true ? "#7fff00" : "",
                    });
                  }

                  ultimo_injection_tag_o2saturado = mobile["injection"];
                }

                let med = mobile["value"];
                mediciones_o2saturado.push(med);
                this.o2saturadp_ultmgl = med.toFixed(2);
              });

              oxigenoValues.forEach((mobile, index) => {
                // zonas contiene  la posicion del array series

                if (index == 0) {
                  ultimo_injection_tag = mobile["injection"];
                } else {
                  if (mobile["injection"] !== ultimo_injection_tag) {
                    zones_oxigeno.push({
                      tag: mobile["injection"],
                      value: index,
                      color:
                        ultimo_injection_tag == false &&
                        mobile["injection"] == true
                          ? "cyan"
                          : "",
                    });
                  } else {
                    zones_oxigeno.push({
                      tag: mobile["injection"],
                      value: index,
                      color: ultimo_injection_tag == true ? "cyan" : "",
                    });
                  }

                  ultimo_injection_tag = mobile["injection"];
                }

                let med = mobile["value"];
                mediciones_oxigeno.push(med);
                this.ultmgl = med.toFixed(2);

                if (this.granularity == "DAY") {
                  categorias.push(
                    mobile["ts"].substr(0, mobile["ts"].length - 8)
                  );
                } else {
                  categorias.push(
                    mobile["ts"].substr(0, mobile["ts"].length - 3)
                  );
                }

                this.fs2 =
                  index +
                  " " +
                  mobile["ts"] +
                  "  " +
                  med +
                  " " +
                  mobile["injection"] +
                  "\n" +
                  this.fs2;

                let t = mobile["ts"].split(" ")[0].split("-");
                const fects = t[2] + "-" + t[1];

                switch (index) {
                  case 0:
                    this.fechaInicialParche = fects;
                    this.horaInicialParche = mobile["ts"].split(" ")[1];
                    break;
                  case mitad:
                    this.fechaMitadParche = fects;
                    this.horaMitadParche = mobile["ts"].split(" ")[1];
                    break;
                  default:
                    this.fechaFinalParche = fects;
                    this.horaFinalParche = mobile["ts"].split(" ")[1];
                }
              });

              this.chartOptions.xAxis.categories = categorias;
              this.chartOptions.series[0].data = mediciones_oxigeno;
              this.chartOptions.series[0].zones = zones_oxigeno;
              this.chartOptions.series[1].data = mediciones_temp;

              this.chartOptions.series[2].data  = mediciones_o2saturado;
              this.chartOptions.series[2].zones = zones_o2saturado;

              resolve({
                temperaturaValues,
                oxigenoValues,
                categorias,
                ultfecha: this.ultfecha,
                firstdate: this.firstdate,
                firsthour: this.firsthour,
                middledate: this.middledate,
                middlehour: this.middlehour,
                lastdate: this.lastdate,
                lasthour: this.lasthour,
                ultmgl: this.ultmgl,
              });
            } catch (error) {
              reject(error);
            }
          });
        } catch (error) {
          console.error(error);
        }
      };

      fetchData()
        .then(() => {
          this.result_mediciones = true;
        })
        .catch((error) => {
          console.error("Error processing data:", error);
        });
    },
    ampliagrafico(obj) {
      this.$emit("ampliaGrafico", obj);
    },
    openmodal(tag, esdefault) {
      console.log(esdefault);
      this.datosSetPoint = {};

      if (tag == "maxORP") {
        this.datosSetPoint.value = this.maxORP.value;
        this.datosSetPoint.descripcion = this.maxORP.descripcion;
      }
      if (tag == "reqO2") {
        this.datosSetPoint.value = this.reqO2.value;
        this.datosSetPoint.descripcion = this.reqO2.descripcion;
        this.datosSetPoint.tipo = tag;
      }
      if (tag == "maxMgl") {
        this.datosSetPoint.value = this.maxMgl.value;
        this.datosSetPoint.descripcion = this.maxMgl.descripcion;
        this.datosSetPoint.tipo = tag;
      }
      console.log("descripcionSetPoint", this.descripcionSetPoint);

      this.modalstate = true;
    },
    openModalGrafico(obj) {
      this.$emit("ampliaGrafico", obj);
    },
    getSetPoints() {
      let setpoints = this.objJaula.setpoints;

      if (Array.isArray(setpoints) && setpoints.length > 0) {
        this.filtraSetPoints(setpoints);
      }

      if (Object.keys(this.reqO2).length > 0) {
        this.reqO2_tipo = this.parametroSetPointsLogin[this.reqO2.idPar].tipo;
        this.reqO2_ume = this.parametroSetPointsLogin[this.reqO2.idPar].unMed;
      }
      if (Object.keys(this.maxMgl).length > 0) {
        this.maxMgl_tipo = this.parametroSetPointsLogin[this.maxMgl.idPar].tipo;
        this.maxMgl_ume = this.parametroSetPointsLogin[this.maxMgl.idPar].unMed;
      }
      if (Object.keys(this.maxORP).length > 0) {
        this.maxORP_tipo = this.parametroSetPointsLogin[this.maxORP.idPar].tipo;
        this.maxORP_ume = this.parametroSetPointsLogin[this.maxORP.idPar].unMed;
      }
    },
    getDefaultSetPoints() {
      let defaultsetpoints =
        this.$store.state.login.userLogin.info.default_setpoints;
      if (Array.isArray(defaultsetpoints) && defaultsetpoints.length > 0) {
        this.filtraDefaultSetPoints(defaultsetpoints);
      }

      if (Object.keys(this.reqO2).length > 0) {
        this.reqO2_ume = this.reqO2.unMedida;
        this.reqO2_esDefault = this.reqO2.esDefault;
        this.reqO2.value = this.reqO2.valor;
      }
      if (Object.keys(this.maxMgl).length > 0) {
        this.maxMgl_ume = this.maxMgl.unMedida;
        this.maxMgl_esDefault = this.maxMgl.esDefault;
        this.maxMgl.value = this.maxMgl.valor;
      }
      if (Object.keys(this.maxORP).length > 0) {
        this.maxORP_ume = this.maxORP.unMedida;
        this.maxORP_esDefault = this.maxORP.esDefault;
        this.maxORP.value = this.maxORP.valor;
      }
    },
    ajusteY() {
      let estimadoMin = this.valorMinY_O2 - 0.4;
      let nuevoValorMin = estimadoMin < 0 ? 0 : estimadoMin;
      let nuevoValorMax = this.valorMaxY_O2 + 0.4;
      // this.fs = nuevoValorMin +  " " + nuevoValorMax

      let estimadoMin1 = this.valorMinY_temp - 8;
      let nuevoValorMin1 = estimadoMin1 < 0 ? 0 : estimadoMin1;
      let nuevoValorMax1 = this.valorMaxY_temp + 0.1;

      let estimadoMin2 = this.valorMinY_o2saturado - 8;
      let nuevoValorMin2 = estimadoMin2 < 0 ? 0 : estimadoMin2;
      let nuevoValorMax2 = this.valorMaxY_o2saturado + 0.1;




      console.log(nuevoValorMin, nuevoValorMax, nuevoValorMin1, nuevoValorMax1);
      this.chartOptions = {
        ...this.chartOptions,

        yAxis: [
          {
            ...this.chartOptions.yAxis[0],
            max: nuevoValorMax,
            min: nuevoValorMin,
          },
          {
            ...this.chartOptions.yAxis[1],
            max: nuevoValorMax1,
            min: nuevoValorMin1,
          }, 
          {
            ...this.chartOptions.yAxis[2],
            max: nuevoValorMax2,
            min: nuevoValorMin2,

          },
        ],
      };
    },

    getSensores() {
      console.log("getSensores");
      //let arrDefaultSetpoints = this.$store.state.login.userLogin.info.default_setpoints;

      let parametros_sensores =
        this.$store.state.login.userLogin.info.parametro_sensores;

      let sensores = this.objJaula.sensores;
      let parametros_filtrados = this.filtrarParametros(
        sensores,
        parametros_sensores
      );
      this.ume1 = "none";
      this.ume2 = "none";
      if (
        Array.isArray(parametros_filtrados) &&
        parametros_filtrados.length > 0
      ) {
 this.id0 = parametros_filtrados[0]?.id ?? 'none';
        this.id1 = parametros_filtrados[1]?.id ?? 'none';
        let id2 = parametros_filtrados[2]?.id ?? 'none';

        this.tipo0 = parametros_filtrados[0]?.tipo ?? 'none';
        this.tipo1 = parametros_filtrados[1]?.tipo ?? 'none';
        this.tipo0 = parametros_filtrados[0]?.tipo ?? 'none';
        let tipo2 = parametros_filtrados[2]?.tipo ?? 'none';

        this.ume0 = parametros_filtrados[0]?.unidad ?? 'none';
        this.ume1 = parametros_filtrados[1]?.unidad ?? 'none';
        let ume2 = parametros_filtrados[2]?.unidad ?? 'none';

        if (this.id0 != "") {
          this.sensor[1].id = this.id0; // oxigeno disuelto

          // leyenda   para el grafico
          this.chartOptions.series[1].name = this.tipo0 + " " + this.ume0;
        }
        if (this.id1 != "") {
          this.sensor[0].id = this.id1;
          // para leyenda del grafico
          this.chartOptions.series[0].name = this.tipo1 + " " + this.ume1;
        }
        if ( id2 != '') {
         
          this.chartOptions.series[2].name =  tipo2 + ' ' +  ume2;
        }
      }
    },
    filtraSetPoints(setpoints) {
      console.log("setpoints", setpoints);
      setpoints.forEach((s) => {
        if (this.tagMappingSetPointsLogin[s.idPar]) {
          this[this.tagMappingSetPointsLogin[s.idPar]] = {
            id: s.id,
            idPar: s.idPar,
            value: s.value,
          };
        }
      });
    },
    filtraDefaultSetPoints(defaultsetpoints) {
      let setpoints = this.objJaula.setpoints;
      defaultsetpoints.forEach((s) => {
        let obj = {
          id: s.id,
          idPar: s.idPar,
          descripcion: s.descripcion,
          tipo: s.tipo,
          unMedida: s.unMedida,
        };
        // busca valor setpoint en objJaula.setpoints

        // si no lo encuentra, poner valor por defecto  s.valor
        let resp = this.filtraValorSetPoint(setpoints, s);
        switch (s.idPar) {
          case 4:
            this.maxORP = obj;
            this.maxORP.valor = resp[0];
            this.maxORP.esDefault = resp[1];
            break;
          case 5:
            this.maxMgl = obj;
            this.maxMgl.valor = resp[0];
            this.maxMgl.esDefault = resp[1];
            this.maxMgl.descripcion = i18n.global.t("oxigeno_disuelto");
            break;
          case 6:
            this.reqO2 = obj;
            this.reqO2.valor = resp[0];
            this.reqO2.esDefault = resp[1];
            this.reqO2.descripcion = i18n.global.t("saturacion_oxigeno");
            break;
        }
      });
    },
    filtraValorSetPoint(setpoints, s) {
      let filteredData = setpoints.filter((item) => item.idPar === s.idPar);
      let valor = 0;
      let esDefault;
      if (filteredData && Array.isArray(filteredData)) {
        valor = filteredData[0] ? filteredData[0].value : s.valor;
        esDefault = filteredData[0] ? false : true;
      }

      return [valor, esDefault];
    },
    filtrarParametros(sensores, parametro_sensores) {
      let resultados = [];

      sensores.forEach((sensorId) => {
        parametro_sensores.forEach((parametro) => {
          if (sensorId === parametro.id) {
            resultados = resultados.concat(parametro.parametros);
          }
        });
      });

      return resultados;
    },
  },
  watch: {
    startDate: function (value) {
      this.result_mediciones = false;
      this.getdataendpoint(value, this.endDate);
    },
    objRangoFechas: function (value) {
      let startDate = value.startDate;
      let endDate = value.endDate;
      this.result_mediciones = false;
      this.getdataendpoint(startDate, endDate);
    },
    injecta_hora: function (valor) {
      console.log("injecta_fecha:", valor);
      this.result_mediciones = false;
    },
    abreCalendario: function (valor) {
      this.loadModalRangoFechas(valor);
    },
  },
  created() {},
  mounted() {
    const setpoints = this.$store.state.login.userLogin.info.default_setpoints;
    let resultado = setpoints.find((item) => item.idPar === 5);
    let tipoMedicion = i18n.global.t("oxigeno_disuelto");
    let umeMedicion = resultado ? resultado.unMedida : null;
    let tituloY = tipoMedicion + " " + umeMedicion;
    this.chartOptions.yAxis[0].title.text = tituloY;

    resultado = setpoints.find((item) => item.idPar === 1);
    tipoMedicion = resultado
      ? resultado.descripcion
      : i18n.global.t("temperatura");
    umeMedicion = resultado
      ? resultado.unMedida
      : i18n.global.t("grados_celsius");

    tituloY = tipoMedicion + " " + umeMedicion;
    this.chartOptions.yAxis[1].title.text = tituloY;

    resultado = setpoints.find(item => item.idPar === 6);
    tipoMedicion = i18n.global.t('oxigeno_saturado') 
    umeMedicion = resultado ? resultado.unMedida : null;
    tituloY = tipoMedicion + ' ' + umeMedicion;
    this.chartOptions.yAxis[2].title.text =  tituloY;


    this.loadModalRangoFechas(this.abreCalendario);
    (this.idJaula = this.objJaula.id),
      this.getdataendpoint(this.startDate, this.endDate);
    this.getSensores();
    // this.getSetPoints();
    this.getDefaultSetPoints();
    this.polldata();
  },
  beforeUnmount() {
    clearInterval(this.polling);
  },
};
</script>
